import React, { useEffect } from 'react';
import GroupButtom from '../../Component/Buttom/group-buttom';
import Carousel from '../../Component/Carousel/carousel';
import { FlexConteiner, Item, ItemLabel, MainConteiner } from '../../Component/Conteiner/conteiner';
import Inform from '../../Component/Inform/inform';
import { api } from '../../Services/drogal-api';
import './doubt.scss';

const Doubt = ({show, onClick, props, onClick1, onClick2, onClick3, onClick4, onClick5, onBannerClick}) => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    return (
        show ? 
            <>
                <Carousel onBannerClick={ onBannerClick }/>
                <MainConteiner className="doubt-margin-top">
                    <Item style={{marginBottom:'30px'}}> 
                        <ItemLabel className="doubt-covid-test" style={{maxWidth:'340px'}}>
                            Faça seu teste do COVID-19 sem
                            complicações e tenha resultado em
                            20 minutos.
                        </ItemLabel>
                    </Item>
                    <Item className="doubt-schedule">
                        <GroupButtom onTestClick={onClick} onWhatsClick={ ()=> { window.open( api.addresses.covidTest.whatssApp,'_blank')}  } />
                    </Item>                    
                </MainConteiner>
                <MainConteiner className="doubt-margin-top">                    
                    <Item className="doubt-item" > 
                        <ItemLabel>
                        <mark className="mark-color">É rápido, fácil e muito seguro.<br/>
                            E o melhor, o resultado sai em até 20 minutos. Veja como:</mark>
                        </ItemLabel>
                        <FlexConteiner style={{maxWidth:'100%', marginTop:'50px'}} >
                            
                            <div className="doubt-display-mobile">
                                <Inform 
                                    param1={ true }
                                    onClick1={ onClick1 } 
                                    onClick2={ onClick2 } 
                                    onClick3={ onClick3 } 
                                    onClick4={ onClick4 }
                                    onClick5={ onClick5 }
                                />                                
                            </div>

                            <div className="doubt-tips">
                                <strong>
                                    Selecione o dia que deseja agendar o teste
                                </strong>                            
                                <div style={{marginTop:'15px'}}>
                                    Selecione a data
                                    que deseja realizar o
                                    agendamento do teste.
                                </div> 
                            </div>
                        
                            <div className="doubt-tips">
                                <strong>
                                    Escolha o local
                                    e horário do teste
                                </strong>                            
                                <div style={{marginTop:'15px'}}>
                                    Busque as farmácias por
                                    cidade e o local mais
                                    próximo de você e irá
                                    aparecer com os
                                    horários disponivéis.
                                </div> 
                            </div>
                        
                            <div className="doubt-tips">
                                <strong>
                                    Selecione o tipo
                                    do teste
                                </strong>                            
                                <div style={{marginTop:'15px'}}>
                                    Selecione o tipo de teste
                                    conforme os dias de
                                    sintomas ou do contato.
                                </div> 
                            </div>
                        
                            <div className="doubt-tips">
                                <strong>
                                    Vá até o local
                                    do exame
                                </strong>                            
                                <div style={{marginTop:'15px'}}>
                                    Chegue com antecedência.
                                    Lembre-se de usar máscara,
                                    levar um documento
                                    com foto e caneta.
                                </div> 
                            </div>
                        
                            <div className="doubt-tips">
                                <strong>
                                    Realize o teste
                                </strong>                            
                                <div style={{marginTop:'15px'}}>
                                    Após fazer o teste, você
                                    poderá realizar o
                                    pagamento do Teste
                                    COVID-19 na própria loja.
                                </div> 
                            </div>
                        
                        </FlexConteiner>                        
                    </Item>
                    <Item className="doubt-display">
                        <Inform 
                        param1={ true }
                        onClick1={ onClick1 } 
                        onClick2={ onClick2 } 
                        onClick3={ onClick3 } 
                        onClick4={ onClick4 }
                        onClick5={ onClick5 }
                    /> 
                    </Item>
                    
                </MainConteiner>
            </> : 
                <span/>
    )    
}

export default React.memo(Doubt)